import { mapEnumToOptions } from '@abp/ng.core';

export enum Region {
  Africa = 0,
  Americas = 1,
  AsiaPacific = 2,
  Europe = 3,
  MiddleEast = 4,
}

export const regionOptions = mapEnumToOptions(Region);
